import i18next from 'i18next';
import { getUserLang } from '../session-storage/session-storage.service';

export const loadLanguage = () => {
  if (getUserLang()) {
    i18next.init({
      supportedLngs: [getUserLang()],
      lng: getUserLang(),
    });
  }
};
